import formApi from '../../services/formApi'


const state = {

}

const mutations = {

}

const actions = {
	async fetchAllFormComponent({ getters }) {
		let token = getters.getAuthService.token
		return await formApi.fetchAllFormComponent(token)
	},
	async fetchDetLayananForm({ getters }, data) {
		// layananForm/get?id_layanan=1&id_dokumen=9
		// layanan Akta KelahiranXXX, di form pelaporan, perlu bagian apa saja
		let token = getters.getAuthService.token
		return await formApi.fetchDetLayananForm(token, data)
	},
	async fetchJenisPelaporan({ getters }) {
		let token = getters.getAuthService.token
		return await formApi.fetchJenisPelaporan(token)
	},
	async storeJenisPelaporanLayanan({ getters }, data) {
		let token = getters.getAuthService.token
		return await formApi.storeJenisPelaporanLayanan(token, data)
	},
	async updateJenisPelaporan({ getters }, data) {
		let token = getters.getAuthService.token
		return await formApi.updateJenisPelaporan(token, data.id, data.form)
	},
	async deleteJenisPelaporanLayanan({ getters }, data) {
		let token = getters.getAuthService.token
		return await formApi.deleteJenisPelaporanLayanan(token, data.id_jenis_pelaporan, data.id_layanan_dokumen)
	},
}

const getters = {

}

export default {
	state,
	mutations,
	actions,
	getters
}